<template>
  <GenericSideMenu
    class="NotifyModal"
    :position="'right'"
    :title="$t('notify.modal.title')"
    @close="uiStore.closeAllModal()"
  >
    <div v-if="!done">
      <div class="mb-12">
        {{ $t('notify.modal.text') }}
      </div>
      <Form
        @submit="onSubmit"
        @click="startValidate"
      >
        <Field
          v-slot="{ field, meta }"
          name="email"
          :rules="validateEmail"
          :value="userStore.isLoggedIn ? userStore.userProfile.email : ''"
        >
          <input
            type="email"
            autocomplete="email"
            class="input mb-12"
            v-bind="field"
            :class="{
              'invalid': meta.validated && !meta.valid
            }"
          >
        </Field>
        <ErrorMessage name="email" class="text-brightRed type-sm-medium mt-4 block mb-12" />
        <button class="btn w-full" :disabled="loading">
          {{ $t('notify.modal.button') }}
        </button>
      </Form>
    </div>
    <div v-else>
      {{ successText }}
    </div>
  </GenericSideMenu>
</template>

<script setup lang="ts">
import { Form, Field, ErrorMessage } from 'vee-validate';
import GenericSideMenu from '~/components/menu/GenericSideMenu.vue';
import { useUiStore } from '~/store/ui';
import { useUserStore } from '~/store/user';
import useApiFetch from '~/composeables/useApiFetch';
import useValidation from '~/composeables/useValidation';

const {
  startValidate,
  validateEmail,
} = useValidation();

const { $t } = useNuxtApp();
const uiStore = useUiStore();
const userStore = useUserStore();
const { apiPost, lastResponseCode } = useApiFetch();
const loading = ref(false);
const done = ref(false);
const successText = ref<string | null>(null);

const onSubmit = async(values: any) => {
  loading.value = true;
  const res = await apiPost(`/products/${uiStore.notifyModalPartNo}/stock-alerts`, {
    email: values.email,
  });
  if (res) {
    done.value = true;
    successText.value = lastResponseCode.code === 201 ? $t('productPage.stockAlertSuccess') : $t('productPage.stockAlertSuccessAgain');
  }
  loading.value = false;
};
</script>

<style scoped lang="postcss">
</style>
